import moment from 'moment';
import { DivisionEnum } from "../../../core/services/data-services/division.service";
import { sortIcdCorporationByOwner } from "../../../core/services/data-services/icd-corporation.service";
import { EditProductOrderStatusModal } from '../../work-order/edit/product-order/edit-product-order-status-modal.component';
import templateUrl from "./rogers-slippage-report-container.component.html";

export const RogersSlippageReportContainerComponent = {
    templateUrl,
    bindings: {
    },
    controller: class {
        constructor(apexApiUrl, icdCorporationService, rogersDashboardService, utilityService, $uibModal,
            divisionService, workOrderService, $q) {
            'ngInject'
            this.loaded = false;
            this.apexApiUrl = apexApiUrl;
            this.icdCorporationService = icdCorporationService;
            this.rogersDashboardService = rogersDashboardService;
            this.utilityService = utilityService;
            this.showFilters = true;
            this.filters = {
                StartDate: moment().startOf("week").toDate(),
                EndDate: moment().endOf("week").toDate(),
                AsOfDate: moment().toDate(),
                Type: 'Summary'
            };
            this.workOrderService = workOrderService;
            this.$uibModal = $uibModal;
            this.$q = $q;
            this.divisionService = divisionService;
            this.showOnlyActive = false;
            this.corporationFilter = function (corp) {
                // fallback to allow list to render
                if (!corp) return false;

                return !this.showOnlyActive || corp.IcdCorporationStatus === 'Active';
            };
        }


        onShowOnlyActiveChange() {
            if (this.showOnlyActive) {
                this.icdCorporations = this.icdCorporationsBK.filter(c => c.IcdCorporationStatus === 'Active');
            } else {
                this.icdCorporations = this.icdCorporationsBK;
            }
        }

        $onInit() {
            const loaded = this.icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout", {
                divisionID: DivisionEnum.Rogers
            })
                .then(icdCorporations => {
                    this.icdCorporations = icdCorporations.sort(sortIcdCorporationByOwner)
                    this.icdCorporationsBK = icdCorporations.slice();
                });
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loaded, "Initial load failed")
            )

            //this.scopeWatcher = this.utilityService.$rootScope.$watch(() => this.showOnlyActive, () => {
            //    this.icdCorporations = [...this.icdCorporations]; // trigger re-evaluation
            //});
        }

        //$ctrl.showOnlyActive = false;



        retrieveRogersSlippageSummaryReport(params) {
            return this.rogersDashboardService.retrieveRogersSlippageSummaryReport(params)
                .then(slippageSummaryReport => {
                    this.showSummaryReport = true;
                    this.slippageSummaryReport = slippageSummaryReport;
                    return this.slippageSummaryReport;
                });
        }

        onUpdateStatus({ productOrder }) {
            const workOrderLoaded = this.workOrderService
                .retrieveWorkOrder(productOrder.WorkOrderID);
            const productOrderStatusesLoaded = this.workOrderService
                .retrieveProductOrderStatuses(this.divisionService.divisionIDs.Rogers);

            this.utilityService.showLoading();
            this.$q.all([workOrderLoaded, productOrderStatusesLoaded])
                .then(([workOrder, statuses]) => {
                    this.utilityService.hideLoading();
                    const order = workOrder.ProductOrders.find(p => p.ProductOrderID === productOrder.ProductOrderID);
                    if (order) {
                        return this.$uibModal.open({
                            ...EditProductOrderStatusModal,
                            resolve: {
                                productOrder: () => order,
                                productOrderStatuses: () => statuses,
                                workOrder: () => workOrder
                            }
                        }).result.then(p => {
                            this.onRefreshData();
                        });
                    }
                })
        }
        retrieveRogersSlippageReport(params) {
            return this.rogersDashboardService.retrieveRogersSlippageReport(params)
                .then(slippageReport => {
                    this.showDetailsReport = true;
                    this.slippageReport = slippageReport;
                    return this.slippageReport;
                });
        }

        onRefreshData() {
            this.clearReportData();
            const params = this.generateQueryParameter();
            let loaded;
            if (this.filters.Type === 'Summary') {
                loaded = this.retrieveRogersSlippageSummaryReport(params);
            } else {
                loaded = this.retrieveRogersSlippageReport(params);
            }
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loaded, "Initial load failed"));
        }

        onExport() {
            const params = this.generateQueryParameter();
            const queryString = this.utilityService.queryStringify(params);
            let api;
            if (this.filters.Type === 'Summary') {
                api = "dashboards/rogers/rogers-slippage-summary-report.xlsx";
            } else {
                api = "dashboards/rogers/rogers-slippage-report.xlsx";
            }
            window.location = this.apexApiUrl + api + queryString;
        }

        clearReportData() {
            this.showDetailsReport = false;
            this.showSummaryReport = false;
            this.slippageSummaryReport = null;
            this.slippageReport = null;
        }

        generateQueryParameter() {
            const params = {
                BookedStartDate: moment(this.filters.StartDate).format("YYYY-MM-DD"),
                BookedEndDate: moment(this.filters.EndDate).format("YYYY-MM-DD"),
                AsOfDate: moment(this.filters.AsOfDate).format("YYYY-MM-DD")
            }
            if (this.filters && this.filters.corporations && this.filters.corporations.length) {
                // Multiple selected owners are supported.
                params.IcdCorporationID = this.filters.corporations.map(p => p.Id);
            }
            return params;
        }
    }
}

